//	Own-want button set
import React from 'react'
import PropTypes from 'prop-types'
import Img from './Img'
import voteTypes from '../enums/voteTypes'
import styles from './UpDownVote.icss'
import icons from '../enums/icons'

class UpDownVote extends React.Component {
	static getDerivedStateFromProps(props, state) {
		return (props.vote && !state.vote) ? { vote: props.vote } : null
	}

	constructor(props) {
		super(props)
		this.state = {
			vote: props.vote
		}
		this.upVoteHandler = this.upVoteHandler.bind(this)
		this.downVoteHandler = this.downVoteHandler.bind(this)
	}

	upVoteHandler() {
		// eslint-disable-next-line react/no-access-state-in-setstate, we do want the initial state
		const vote = this.state.vote === voteTypes.UP ? voteTypes.NEUTRAL : voteTypes.UP
		const prevVote = this.state.vote
		this.setState({ vote })
		this.props.onVoteChange(vote, prevVote)
	}

	downVoteHandler() {
		// eslint-disable-next-line react/no-access-state-in-setstate, we do want the initial state
		const vote = this.state.vote === voteTypes.DOWN ? voteTypes.NEUTRAL : voteTypes.DOWN
		const prevVote = this.state.vote
		this.setState({ vote })
		this.props.onVoteChange(vote, prevVote)
	}

	render() {
		const { vote } = this.state
		const upImgSrc = vote === voteTypes.UP ? icons.redUpvote : icons.blackUpvote
		const downImgSrc = vote === voteTypes.DOWN ? icons.redDownvote : icons.blackDownvote

		return (
			<span className={styles.container}>
				<span className={styles.division}>
					<Img content={upImgSrc} onClick={this.upVoteHandler} />
				</span>
				<span className={styles.text}>
					{this.props.score}
				</span>
				<span className={styles.division}>
					<Img content={downImgSrc} onClick={this.downVoteHandler} />
				</span>
			</span>
		)
	}
}

UpDownVote.propTypes = {
	onVoteChange: PropTypes.func,
	vote: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	score: PropTypes.number
}

UpDownVote.defaultProps = {
	onVoteChange: () => {},
	vote: undefined,
	score: 0
}

UpDownVote.contextTypes = {
	translate: PropTypes.func
}

export default UpDownVote



// WEBPACK FOOTER //
// ./src/components/UpDownVote.jsx